module.exports = __webpack_public_path__ + "img/icon_msb_registration_00.6945ae97.png";